import { render } from "./Instagram.vue?vue&type=template&id=60eff105&scoped=true"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"

import "./Instagram.vue?vue&type=style&index=0&id=60eff105&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eff105"]])

export default __exports__